<template>
  <div class="main">
    <div class="main_view">
      <div class="main_left">
        <div class="_left_top">
          <div class="title" @click="fn">{{ sourceData.PaperTitle }}</div>
          <div class="progress">
            <p>已经完成：{{ completeNum }}/{{ planNum }}</p>
            <div class="Progress">
              <div class="piece" :style="'width:' + ProgressBar() + '%'">
                <span>{{ ProgressBar().toFixed(2) + "%" }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 题目 -->
        <div class="the_title">
          <div v-for="(item, index) in answerArr" :key="index">
            <Atest
              v-if="item.Type == 'ATEST' && anIndex == index"
              :TestItems="item"
              :anIndex="anIndex"
              :userAbswerArr="userAbswerArr"
              @userAbswer="saveAnswer"
            />
            <Xtest
              v-else-if="item.Type == 'XTEST' && anIndex == index"
              :TestItems="item"
              :anIndex="anIndex"
              :userAbswerArr="userAbswerArr"
              @userAbswer="saveAnswer"
            />
            <Tktest
              v-else-if="item.Type == 'TKTEST' && anIndex == index"
              :TestItems="item"
              :userAbswerArr="userAbswerArr"
              :anIndex="anIndex"
              @userAbswer="saveAnswer"
            />
            <Pdtest
              v-else-if="item.Type == 'PDTEST' && anIndex == index"
              :TestItems="item"
              :userAbswerArr="userAbswerArr"
              :anIndex="anIndex"
              @userAbswer="saveAnswer"
            />
            <Jdtest
              v-else-if="item.Type == 'JDTEST' && anIndex == index"
              :TestItems="item"
              :userAbswerArr="userAbswerArr"
              :anIndex="anIndex"
              @userAbswer="saveAnswer"
            />
            <A3test
              v-else-if="item.Type == 'A3TEST' && anIndex == index"
              :TestItems="item"
              :userAbswerArr="userAbswerArr"
              :anIndex="anIndex"
              @userAbswer="saveAnswer"
            />
            <Btest
              v-else-if="item.Type == 'BTEST' && anIndex == index"
              :TestItems="item"
              :userAbswerArr="userAbswerArr"
              :anIndex="anIndex"
              @userAbswer="saveAnswer"
            />
          </div>
          <div @click="anIndexType('1')" class="next">
            <img src="@/assets/oldKhy/next-question.png" alt="" />
            <span>下一题</span>
          </div>
        </div>
      </div>
      <div class="main_right">
        <div class="exam_time">
          <img src="@/assets/oldKhy/clock.png" alt="" />
          <p>{{ textTimer }}</p>
        </div>
        <div class="submit">
          <div @click="theirPapers">
            <img src="@/assets/oldKhy/marking.png" alt="" />
            <span>交卷</span>
          </div>
          <div @click="anIndexType('0')">
            <img src="@/assets/oldKhy/prev-question.png" alt="" />
            <span>上一题</span>
          </div>
          <div @click="anIndexType('1')">
            <img src="@/assets/oldKhy/next-question.png" alt="" />
            <span>下一题</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部答题卡 -->
    <div
      class="answer_card"
      style="
        position: fixed;
        left: 50%;
        transform: translateX(-50%);
        transition: bottom 0.8s ease-out;
      "
      :style="
        anState == false ? 'bottom:' + '0px' : 'bottom:' + anHeight + 'px'
      "
      v-if="answerArr.length != 0"
    >
      <div class="card_hader" @click="anStateFun">
        <p>{{ anState == false ? "隐藏" : "显示" }}</p>
        <p>答题卡(剩下{{ answerArr.length - userAbswerArr.length }}道题)</p>
      </div>
      <p class="blue"></p>
      <div class="answer_box" ref="popup1">
        <div
          v-for="(item, index) in answerArr"
          :key="index"
          :class="AnswerNumType(item, index)"
          @click="switchTitle(index)"
        >
          {{ index + 1 }}
        </div>
      </div>
    </div>
    <Popup :infoType="infoType" ref="popup" />
  </div>
</template>

<script>
import ksPcApi from "@/api/examPc";
import loginvuex from "@/store/index";
import Atest from "./Atest.vue"; // A题型
import Xtest from "./Xtest.vue"; // X题型
import Tktest from "./Tktest.vue"; // 填空题
import Pdtest from "./Pdtest.vue"; // 判断题
import Jdtest from "./Jdtest.vue"; // 名词解释 || 问答题
import A3test from "./A3test.vue"; // A3题型
import Btest from "./Btest.vue"; // B题型 C题型

import { todealWithData, facilityHandleata } from "@/utils/topicImg"; // 题型图片处理
import datas from "./data";
import Popup from "./Popup.vue";
export default {
  data() {
    return {
      planNum: 13, // 总数
      completeNum: 0, // 当前
      num: 0, // 宽度百分比
      time: 120, // 考试时间倒计时
      timer: null, // 定时器
      textTimer: "00",
      isClick: true, // 定时器开启关闭状态
      answerArr: [],
      anState: false, // 答题卡展开关闭状态
      anHeight: "150", // 答题卡盒子的高度
      anIndex: 0, // 当前显示的题目
      userAbswerArr: [], // 答案综合
      infoType: 0, // 交卷提示
      sourceData: [], // 原始请求回来的数据
      ExamID: "", // 当前考试ID
      userID: "", //userID
    };
  },
  components: {
    Atest,
    Xtest,
    Tktest,
    Pdtest,
    Jdtest,
    A3test,
    Btest,
    Popup,
  },
  methods: {
    // 答题卡开启状态
    anStateFun() {
      this.anState = !this.anState;
      if (this.anState == true) {
        this.anHeight = this.$refs.popup1.offsetHeight;
      }
    },
    init() {
      const paperMode = this.$route.query.paperMode;
      console.log(paperMode,'paperMode');
      if (
        paperMode === "unified_difflever" ||
        paperMode === "random_difflever"
      ) {
        // 难易度组卷取题
        this.getFacilityAnswer();
      } else {
        this.getAnswerlist();
      }
    },
    // 取题
    async getAnswerlist() {
      const obj = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
        examID: this.$route.query.examID,
        paperID: this.$route.query.paperID || this.$route.query.paperid,
        source: "khy",
      };
      const { data } = await ksPcApi.getTestInfo(obj);
      if (data.Status == 200) {
        this.time = data.Data.SpendTime; // 考试总时间
        this.sendCode(); // 定时器倒计时开始
        this.answerArr = todealWithData(data.Data); // 数据题型格式处理
        console.log(this.answerArr);
        this.planNum = this.answerArr.length; // 题目的长度用于答题卡页面渲染
        this.sourceData = data.Data; // 原始数据不动
        this.ExamID = data.Data.ExamInfo.ExamID;
        localStorage.setItem(
          // 缓存key  sourceData + 当场考试ID
          `sourceData${this.ExamID}_${this.userID}`,
          JSON.stringify(this.sourceData)
        ); // 缓存本地用于缓存交卷
      } else {
        if (data.Data == "已超过考试次数") {
          this.$refs.popup.dialogVisibleObj.examFinish = true;
          return;
        }
        this.$message.error(data.Msg);
      }
    },
    // 难易度取题
    async getFacilityAnswer() {
      const obj = {
        examID: this.$route.query.examID,
        source: "khy",
      };
      const { data } = await ksPcApi.getFacilityTestInfo(obj);
      if (data.Status == 200) {
        this.time = data.Data.SpendTime; // 考试总时间
        this.sendCode(); // 定时器倒计时开始
        this.answerArr = facilityHandleata(data.Data); // 数据题型格式处理
        this.planNum = this.answerArr.length; // 题目的长度用于答题卡页面渲染
        this.sourceData = data.Data; // 原始数据不动
        this.ExamID = data.Data.ExamInfo.ExamID;
        localStorage.setItem(
          // 缓存key  sourceData + 当场考试ID
          `sourceData${this.ExamID}_${this.userID}`,
          JSON.stringify(this.sourceData)
        ); // 缓存本地用于缓存交卷
      } else {
        if (data.Data == "已超过考试次数") {
          this.$refs.popup.dialogVisibleObj.examFinish = true;
          return;
        }
        this.$message.error(data.Msg || data.Data);
      }
    },
    // 获取考试倒计时时间
    async sendCode() {
      const obj = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
        examID: this.$route.query.examID,
      };
      const { data } = await ksPcApi.examTimeGet(obj);
      if (data.Status == 200) {
        // this.time = data.Data[0].
        // TestBeginTime 记录考试开考时间  nowTime 服务器返回的现在时间
        // 现在时间 - 开考时间 = 已经用时的考试时间   考试总时间-用时时间=剩余考试的时间
        localStorage.setItem(
          // 缓存key  TestBeginTime + 当场考试ID
          `TestBeginTime${this.$route.query.examID}_${this.userID}`,
          JSON.stringify(data.Data[0].TestBeginTime)
        );
        let timeDiff = this.$moment(data.Data[0].nowTime).diff(
          this.$moment(data.Data[0].TestBeginTime),
          "seconds"
        ); // 得到上次考试用时时间 单位秒
        this.time = this.time * 60 - timeDiff; // 获得秒单位
        this.timeCode();
      } else {
        this.$message.error(data.Msg);
      }
    },
    timeCode() {
      if (this.isClick == false) {
        return;
      }
      this.isClick = false;
      this.loading(); // 启动定时器
      this.timer = setInterval(() => {
        if (this.time <= 0) {
          // 定时器执行完的操作
          this.timer && this.clearTimer(); // 关闭定时器
          this.infoType = "sys";
          this.$refs.popup.theirPapersFun("sys"); // 系统收卷
        } else {
          this.loading();
        }
      }, 1000);
    },
    loading() {
      // 启动定时器
      this.time -= 1;
      this.textTimer = this.$moment.utc(this.time * 1000).format("HH:mm:ss");
    },
    clearTimer() {
      // 清除定时器
      clearInterval(this.timer);
      this.timer = null;
    },
    // 切换题目
    switchTitle(index) {
      this.anIndex = index;
    },
    // 答案
    saveAnswer(a) {
      if (this.userAbswerArr.length == 0) {
        this.userAbswerArr.push(a);
      } else {
        const index = this.userAbswerArr.findIndex((item) => {
          return item.ChildTableID === a.ChildTableID;
        });
        if (index !== -1) {
          // 选择新答案的时候，删除之前的就答案
          this.userAbswerArr.splice(index, 1);
        }
        this.userAbswerArr.push(a);
        // 过滤掉填空题做了又删的情况
        this.userAbswerArr = this.userAbswerArr.filter((item) => {
          return item.UserAnswer != null;
        });
      }
      console.log(this.userAbswerArr,'???this.userAbswerArr');
      
    },
    // 上一题下一题切换
    anIndexType(type) {
      if (type == "0") {
        // 上一题
        if (this.anIndex <= 0) {
          this.$message({
            message: "警告，当前已经是第一题",
            type: "warning",
          });
        } else {
          this.anIndex--;
        }
        console.log(this.anIndex);
      } else if (type == "1") {
        // 下一题
        if (this.anIndex >= this.answerArr.length - 1) {
          this.$message({
            message: "警告，当前已经是最后一道题",
            type: "warning",
          });
        } else {
          this.anIndex++;
        }
      }
    },
    // 交卷提示框状态
    theirPapers() {
      if (this.userAbswerArr.length == 0) {
        this.infoType = 0;
      } else if (this.answerArr.length - this.userAbswerArr.length > 0) {
        this.infoType = 1;
        // 您还有13道题未答，交卷后的试卷将不能再作答，您确定要交卷？
      } else {
        this.infoType = 2;
        // 交卷后的试卷将不能再作答，您确定要交卷？
      }
      this.$refs.popup.dialogVisibleObj.carryOutInfo = true;
    },
    fn() {
      // this.$refs.popup.theirPapersFun('sys')
      this.$refs.popup.dialogVisibleObj.examFinish = true;
    },
  },
  beforeDestroy() {
    this.clearTimer();
  },
  computed: {
    ProgressBar() {
      return function () {
        this.completeNum = this.userAbswerArr.length; // 已答提数
        this.num = (this.completeNum / this.planNum).toFixed(2) * 100;
        return this.num;
      };
    },
    AnswerNumType() {
      return function (row, index) {
        let type = this.userAbswerArr.findIndex((item) => {
          return (
            item.ChildTableID == row.TestID ||
            item.ChildTableID == row.BTestItemID ||
            item.ChildTableID == row.A3TestItemID
          );
        });
        if (index == this.anIndex) {
          return "bd";
        } else if (type != -1) {
          return "backBlue";
        } else {
          return "";
        }
      };
    },
  },
  watch: {
    // immediate: true,
    anIndex(newValue, oldValue) {
      if (newValue !== null) {
        localStorage.setItem(`anIndex${this.ExamID}_${this.userID}`, newValue); // 题目索引缓存本地
        // localStorage.setItem('userAbswerArr',this.userAbswerArr) // 缓存用户作答
      }
      // console.log(oldValue, "oldValue");
      // console.log(newValue, "newValue");
    },
    userAbswerArr(newValue, oldValue) {
      localStorage.setItem(
        `userAbswerArr${this.ExamID}_${this.userID}`,
        JSON.stringify(newValue)
      ); // 缓存用户作答
      // console.log(oldValue, "oldValue");
      // console.log(newValue, "newValue");
    },
  },
  created() {
    this.userID = JSON.parse(loginvuex.state.userlist).userID;
    if (
      localStorage.getItem(`anIndex${this.$route.query.examID}_${this.userID}`)
    ) {
      this.anIndex = localStorage.getItem(
        `anIndex${this.$route.query.examID}_${this.userID}`
      ); // 刷新接收
    }
    if (
      localStorage.getItem(
        `userAbswerArr${this.$route.query.examID}_${this.userID}`
      )
    ) {
      // 刷新接收用户答案
      this.userAbswerArr = JSON.parse(
        localStorage.getItem(
          `userAbswerArr${this.$route.query.examID}_${this.userID}`
        )
      ); // 刷新接收
    }
    // this.getAnswerlist();
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
  user-select: none;
}
.main_view {
  display: flex;
  // justify-content: space-between;
  margin-top: 38px;
  .main_left {
    width: 930px;
    // border: 1px solid #000;
    height: 800px;
    margin-right: 20px;
    ._left_top {
      border: 1px solid #dddddd;
      box-shadow: 2px 2px 5px #dddddd;
    }
    .title {
      height: 70px;
      font-size: 30px;
      font-weight: 400;
      letter-spacing: 1px;
      padding: 24px;
      //   border: 1px solid #dddddd;
    }
    .progress {
      display: flex;
      align-items: center;
      min-height: 58px;
      padding-left: 12px;
      background: #f7f7f7;
      border-top: 1px solid #ddd;
      .progress {
        width: 620px;
        margin-left: 24px;
        border-top: none !important;
      }
    }
  }
  .main_right {
    width: 170px;
    user-select: none;

    .exam_time {
      width: 140px;
      height: 150px;
      box-shadow: 2px 2px 5px #dddddd;
      background: #f7f7f7;
      border-color: #ddd;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      p {
        margin-top: 16px;
      }
    }
    .submit {
      display: flex;
      flex-direction: column;
      width: 140px;
      height: 190px;
      box-shadow: 2px 2px 5px #dddddd;
      background: #fff;
      border-color: #ddd;
      margin-top: 36px;
      user-select: none;
      > div {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
        border-bottom: 1px solid #ddd;
        cursor: pointer;
        &:nth-child(1) {
          span {
            letter-spacing: 8px;
            color: #119be5;
          }
        }
        span {
          width: 48px;
          margin-left: 18px;
        }
        &:active {
          background: rgba(238, 238, 238, 0.767);
        }
      }
    }
  }
}
.Progress {
  width: 620px;
  height: 40px;
  border: 1px solid #ddd;
  margin-left: 40px;
  .piece {
    height: 38px;
    line-height: 38px;
    background: #b3e5ff;
    transition: 0.3s;
    span {
      margin-left: 12px;
    }
  }
}
.the_title {
  min-height: 400px;
  border: 1px solid #dddddd;
  box-shadow: 2px 2px 5px #dddddd;
  margin-top: 24px;
}
.answer_card {
  height: 64px;
  .card_hader {
    width: 225px;
    height: 55px;
    background: #119ce5;
    border-radius: 5px 5px 0 0;
    text-align: center;
    margin: 0px auto;
    color: #fff;
    cursor: pointer;
    p {
      height: 15px;
      &:nth-child(1) {
        margin-bottom: 8px;
      }
    }
  }
  .blue {
    width: 800px;
    height: 10px;
    background: #119ce5;
    margin: 0 auto;
  }
  .answer_box {
    width: 800px !important;
    margin: 0 auto;
    max-height: 250px;
    overflow-x: hidden;
    overflow-y: auto;
    background: #eaeaea;
    display: flex;
    flex-wrap: wrap;
    // padding: 20px 4px;
    box-sizing: border-box;
    > div {
      border: 1px solid #dadada !important;
      width: 35px !important;
      background: #f7f7f7;
      line-height: 35px;
      margin: 5px 4px;
      text-align: center;
      font-size: 16px;
      // color: #000;
      cursor: pointer;
      &:hover {
        background: #b3e5ff;
      }
    }
  }
}
.bd {
  border: 2px solid rgb(0, 0, 0) !important;
}
.backBlue {
  background: #119ce5 !important;
  color: #fff;
}
.next {
  width: 150px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ddd;
  cursor: pointer;
  user-select: none;
  margin-left: 36px;
  margin-bottom: 24px;
}
</style>
